/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown>, completed: NonNullable<unknown> }} Err_Tournament_Max_Rounds_Below_CompletedInputs */



/**
* | output |
* | --- |
* | "max_rounds ({max}) cannot be less than completed rounds ({completed})" |
*
* @param {Err_Tournament_Max_Rounds_Below_CompletedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_max_rounds_below_completed = /** @type {((inputs: Err_Tournament_Max_Rounds_Below_CompletedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Max_Rounds_Below_CompletedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`max_rounds (${i?.max}) ne peut pas être inférieur aux rondes complétées (${i?.completed})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`max_rounds (${i?.max}) no puede ser inferior a las rondas completadas (${i?.completed})`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`max_rounds (${i?.max}) não pode ser inferior às rodadas concluídas (${i?.completed})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`max_rounds (${i?.max}) non può essere inferiore ai round completati (${i?.completed})`)
	return /** @type {LocalizedString} */ (`max_rounds (${i?.max}) cannot be less than completed rounds (${i?.completed})`)
});